module.exports = "https://cdn2-fs.clearscore.com/flux/images/ae40a95ef064bca73ae22142b2680fe1.jpg";